
<p-progressSpinner *ngIf="spinner"></p-progressSpinner>
<div #scrollMe class="background-gradient p-4" style="overflow-y:auto; height:500px;">
    <div style="white-space: pre-wrap;" *ngFor="let msg of messages">
        <div *ngIf="msg.fromSubscriber" class="d-flex flex-row justify-content-start p-1">
            <div><img class="user-picture"
                [src]="chatData.subscriberUserProfilePictureUrl ? chatData.subscriberUserProfilePictureUrl:'./assets/images/icons/profile-picture-placeholder-01.svg'"
                alt="profile-picture"></div>
            <div class="d-flex p-2 ms-2 align-items-center sub-message">{{msg.messageText}}</div>
            <div style="width:20%;"></div>
        </div>
        <div *ngIf="!msg.fromSubscriber" class="d-flex flex-row justify-content-end p-1">
            <div style="width:20%;"></div>
            <div class="d-flex p-2 align-items-center adv-message">{{msg.messageText}}</div>
        </div>
    </div>
</div>
<div class="d-flex flex-row mt-4 ms-4 me-4" >
    <textarea class="w-100" (keydown.enter)="sendMessage(myMsg)" [(ngModel)]="myMsg" [rows]="1" pInputTextarea [autoResize]="true" placeholder="{{ 'INFO.PLACEHOLDER' | translate }}"></textarea>
    <div style="cursor:pointer" (click)="sendMessage(myMsg)">
        <i class="p-3 pi pi-send" style="font-size: 1.5rem;"></i>
    </div>
</div>
